import React, { useContext } from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Loader from "../Component/Loader";

function NonAuthLayout() {
  // const { loading } = useContext(MyContext);

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <div className="page-wrapper">
      <div className={``}>
        <Outlet />
      </div>
    </div>
  );
}

export default NonAuthLayout;
